<template>
  <div :style="scaleStyle" ref="previewMain" :class="{ 'is-sample': isSample, 'is-preview': !isSample }">
    <div class="doc-paper preview keirekisho" :id="idPrefix + 'preview-page-01'">
      <div class="keirekisho-wapper">
        <div class="keirekisho-header">
          <div class="flex" style="display: flex; justify-content: space-between; align-items: center;">
            <h1 class="title" style="border-bottom: none;">スキルシート</h1>
            <div class="date data text-right" :data-highlight="highlightMessage" @click="goCardTo('create-date')"
              :class="highLightClass('create-date')" style="margin-top: 0;">
              <span v-html="formatedCreateDate"></span>
            </div>
          </div>

          <div class="keirekisho-content" style="border: 2px solid #000; margin-top: 10px;">
            <div class="flex" style="display: flex; border-bottom: 1px solid #000;" @click="goCardTo('profile')">
              <div style="display: flex ; align-items: center; justify-content: center; width: 150px; border-right: 1px solid #000;">ふりがな</div>
              <div style="text-align: left; padding: 0 10px; width: calc(100% - 150px); height: 24px; overflow: hidden;">{{ basicData.lastNameFurigana }}&emsp;{{ basicData.firstNameFurigana }}</div>
            </div>
            <div class="flex" style="display: flex; border-bottom: 1px solid #000;" @click="goCardTo('profile')">
              <div style="display: flex ; align-items: center; justify-content: center; width: 150px; border-right: 1px solid #000;">名前</div>
              <div style="text-align: left; padding: 0 10px; width: calc(100% - 150px); height: 24px; overflow: hidden;">{{ basicData.lastName }}&emsp;{{ basicData.firstName }}</div>
            </div>
            <div class="flex" style="display: flex; border-bottom: 1px solid #000;" @click="goCardTo('skills-to-use')">
              <div style="display: flex ; align-items: center; justify-content: center; width: 150px; border-right: 1px solid #000;">スキル</div>
              <div style="text-align: left; padding: 0 10px; width: calc(100% - 150px); height: 24px; overflow: hidden;">{{ formatData.skills }}</div>
            </div>
            <div class="flex" style="display: flex; border-bottom: 1px solid #000;" @click="goCardTo('intelligence')">
              <div style="display: flex ; align-items: center; justify-content: center; width: 150px; border-right: 1px solid #000;">活かせる経験・知識</div>
              <div style="text-align: left; padding: 0 10px; width: calc(100% - 150px);">{{ formatData.intelligence }}</div>
            </div>
            <div class="flex" style="display: flex;" @click="goCardTo('other-skills')">
              <div style="display: flex ; align-items: center; justify-content: center; width: 150px; border-right: 1px solid #000;">その他</div>
              <div style="text-align: left; padding: 0 10px; width: calc(100% - 150px);">{{ formatData.otherskills }}</div>
            </div>
          </div>
          <!--<div class="data text-right"
               :data-highlight="highlightMessage"
               @click="goCardTo('profile')"
               :class="highLightClass('profile')">
          <span class="name">{{ basicData.lastName }}&emsp;{{ basicData.firstName }}</span>
        </div>-->
        </div>
        <div class="keirekisho-content">
          <!--<h2 v-if="formatData.jobHistories && formatData.jobHistories.length" id="job-history">職務経歴</h2>-->
          <div class="job-history" :data-highlight="highlightMessage" @click="goCardTo('job-history')"
            :class="highLightClass('job-history')">
            <div v-for="item in formatData.jobHistories" :key="item.uuid">
              <h3 v-if="item.companyName || item.startYear || item.startMonth || item.endYear || item.endMonth"
                class="company-name" :style="formatData.selFontStyle">{{ item.companyName }}
                <span v-if="item.isContinuing && item.startYear && item.startMonth">{{ item.startYear }}年 {{
                  item.startMonth }}月 〜
                  在職中</span>
                <span v-else-if="item.isContinuing && item.startYear && !item.startMonth">{{ item.startYear }}年 〜
                  在職中</span>
                <span v-else-if="item.isContinuing && !item.startYear && item.startMonth">{{ item.startMonth }}月 〜
                  在職中</span>
                <span v-else-if="item.isContinuing && !item.startYear && !item.startMonth">在職中</span>
                <span v-else><template v-if="item.startYear">{{ item.startYear }}年</template> <template
                    v-if="item.startMonth">{{ item.startMonth }}月</template> <template
                    v-if="item.endYear || item.endMonth">〜</template> <template v-if="item.endYear">{{
                    item.endYear}}年</template>
                  <template v-if="item.endMonth">{{ item.endMonth }}月</template></span>
              </h3>

              <!--<div class="organization" v-if="item.businessArea || item.numberOfEmployees || item.capitalStock" :style="formatData.selFontStyle">
              <p v-if="item.businessArea"><pre :style="formatData.selFontStyle">事業内容：{{ item.businessArea}}</pre></p>
              <p v-if="item.capitalStock && item.numberOfEmployees">資本金：{{ item.capitalStock }}万円、従業員数：{{ item.numberOfEmployees }}名</p>
              <p v-else-if="item.capitalStock && !item.numberOfEmployees">資本金：{{ item.capitalStock }}万円</p>
              <p v-else-if="!item.capitalStock && item.numberOfEmployees">従業員数：{{ item.numberOfEmployees }}名</p>
            </div>-->

              <div v-for="(item, index) in item.projects" :key="index" :style="formatData.selFontStyle" style="margin-bottom: 20px;">
                <h5 v-if="item.projectTitle || item.startYear || item.startMonth || item.endYear || item.endMonth">{{
                  item.projectTitle }}<span><template v-if="item.startYear">{{ item.startYear }}年</template> <template
                      v-if="item.startMonth">{{ item.startMonth }}月</template> <template
                      v-if="item.endYear || item.endMonth">〜</template> <template v-if="item.endYear">{{
                      item.endYear}}年</template> <template v-if="item.endMonth">{{ item.endMonth }}月</template></span>
                </h5>
                <pre :style="formatData.selFontStyle" style="margin-bottom: 5px;">{{ item.contentsOfProject }}</pre>
                <div v-if="item.dev"><span style="display: inline-block; width: 100px;">環境・言語</span>{{ item.dev }}</div>
                <div v-if="item.position"><span style="display: inline-block; width: 100px;">役割・役職</span>{{ item.position }}</div>
                <div v-if="item.numberOfTeam"><span style="display: inline-block; width: 100px;">規模・人数</span>{{ item.numberOfTeam }}名</div>
                <div v-if="item.phase1 || item.phase2 || item.phase3 || item.phase4 || item.phase5 || item.phase6"><span style="display: inline-block; width: 100px;">担当工程</span>
                  <span :style="{
                    border: item.phase1 ? '1px solid #000' : null,
                    borderRadius: item.phase1 ? '5px' : null,
                    padding: item.phase1 ? '1px 2px' : null
                  }">要件定義</span> ／ 
                  <span :style="{
                    border: item.phase2 ? '1px solid #000' : null,
                    borderRadius: item.phase2 ? '5px' : null,
                    padding: item.phase2 ? '1px 2px' : null
                  }">基本設計</span> ／ 
                  <span :style="{
                    border: item.phase3 ? '1px solid #000' : null,
                    borderRadius: item.phase3 ? '5px' : null,
                    padding: item.phase3 ? '1px 2px' : null
                  }">詳細設計</span> ／ 
                  <span :style="{
                    border: item.phase4 ? '1px solid #000' : null,
                    borderRadius: item.phase4 ? '5px' : null,
                    padding: item.phase4 ? '1px 2px' : null
                  }">実装・単体</span> ／ 
                  <span :style="{
                    border: item.phase5 ? '1px solid #000' : null,
                    borderRadius: item.phase5 ? '5px' : null,
                    padding: item.phase5 ? '1px 2px' : null
                  }">結合テスト</span> ／ 
                  <span :style="{
                    border: item.phase6 ? '1px solid #000' : null,
                    borderRadius: item.phase6 ? '5px' : null,
                    padding: item.phase6 ? '1px 2px' : null
                  }">保守・運用</span>
                </div>
              </div>
            </div>
          </div>

          <h2 v-if="formatData.prMessage">自己PR</h2>
          <div v-if="formatData.prMessage" class="prMessage" id="pr-message" :data-highlight="highlightMessage"
            @click="goCardTo('pr-message')" :class="highLightClass('pr-message')">
            <!-- <div class="label">{{ currentCardId }} {{ isCardChanged }}testtesttest</div> -->
            <pre :style="formatData.selFontStyle">{{ formatData.prMessage }}</pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ShokurekishoPreviewMixin from '@/mixins/shokurekisho-preview-mixin'
export default {
  name: 'shokurekishoPreview',
  mixins: [ShokurekishoPreviewMixin],
  data: function () {
    return {}
  },
  methods: {
    checkValid: function () {
    }
  }
}
</script>
